import * as CommonUtilities from "./../../../common/utils/CommonUtils.js";

/* =============================================================================
   One store in the picker.

   ⚠⚠ READ THIS BEFORE CHANGING THE MARKUP.
   App.js does  event.target.getAttribute('data-locNum')  — TARGET, not
   currentTarget. That is the opposite of handleProductMenuClick. It means the
   element actually clicked must itself carry data-locnum: if the customer hits
   a <span> inside the button, event.target is that span, the attribute is null,
   and selecting a store silently does nothing.

   Two defences, both needed:
     1. data-locnum sits on every element that has onClick.
     2. .wo-loc__row * and .wo-loc__pick * get pointer-events:none in theme.css,
        so a click can never land on a child.

   ⚠ The catering check is not decoration. When PickupMenuType is 'webordering'
   the open/closed state comes from isAllowS8WebCateringOrder, NOT
   isAllowOnlineOrder. Collapsing the two shows the wrong trading state.
   ============================================================================= */

export default function Location(props) {

    // Catering Check
    const isOpen = CommonUtilities.StaticFields.PickupMenuType === 'webordering'
        ? props.data.isAllowS8WebCateringOrder
        : props.data.isAllowOnlineOrder;

    const isSelected = props.currentLocation.LocationID == props.data.locationNumber;

    const suburbLine = `${props.data.locationSuburb || ''} ${props.data.locationState || ''} ${props.data.locationPostCode || ''}`.trim();

    return (
        <div
            className={`wo-loc__row${isSelected ? ' wo-loc__row--on' : ''}`}
            onClick={isSelected ? null : props.handleSelectLocation}
            data-locnum={props.data.locationNumber}
        >
            <span className="wo-loc__pin" aria-hidden="true">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z" />
                    <circle cx="12" cy="10" r="2.6" />
                </svg>
            </span>

            <span className="wo-loc__body">
                <span className="wo-loc__name">{props.data.locationName}</span>
                <span className="wo-loc__addr">
                    {props.data.locationAddress1}
                    {props.data.locationAddress2 ? `, ${props.data.locationAddress2}` : ''}
                </span>
                {suburbLine && <span className="wo-loc__addr">{suburbLine}</span>}
            </span>

            <span className="wo-loc__right">
                <span className={`wo-loc__status${isOpen ? '' : ' wo-loc__status--shut'}`}>
                    <i aria-hidden="true"></i>{isOpen ? 'Open' : 'Closed'}
                </span>
                {isSelected
                    ? <button
                        type="button"
                        className="wo-loc__pick wo-loc__pick--on"
                        name="locationGroup"
                        value={props.data.locationNumber}
                        data-locnum={props.data.locationNumber}
                      >Selected</button>
                    : <button
                        type="button"
                        className="wo-loc__pick"
                        name="locationGroup"
                        onClick={props.handleSelectLocation}
                        value={props.data.locationNumber}
                        data-locnum={props.data.locationNumber}
                      >Select</button>}
            </span>
        </div>
    )
}
